/** The device's IANA time zone ('Europe/Istanbul'); undefined if the browser can't tell. */
export const browserTimeZone = (): string | undefined => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
  } catch {
    return undefined;
  }
};

/** Every IANA zone the browser knows, for the profile picker (a short fallback on old browsers). */
export const listTimeZones = (): string[] => {
  const supportedValuesOf = (Intl as unknown as { supportedValuesOf?: (key: string) => string[] }).supportedValuesOf;
  if (supportedValuesOf) {
    try {
      return supportedValuesOf('timeZone');
    } catch {}
  }
  const own = browserTimeZone();
  return Array.from(new Set(['UTC', 'Europe/Istanbul', ...(own ? [own] : [])]));
};
